export let hress1eColumns = () => {
  let indexColumns = [{
    key: 'kpino',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'kpiitem',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '50',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_status',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '100',
    style: 'min-width: 120px;',
    class: 'align-center'
  }, {
    key: 'dtetarg',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'target',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }]

  let detail1Columns = [{
    key: 'workno',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'workitem',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '130',
    style: 'min-width: 200px;'
  }, {
    key: 'actbedon',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '140',
    style: 'min-width: 100px;'
  }, {
    key: 'spsubport',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '150',
    style: 'min-width: 100px;'
  }]

  let detail2Columns = [{
    key: 'dteapkpi',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '170',
    class: 'align-center',
    style: 'min-width: 80px;',
    inlineType: 'date',
    validateRules: 'requiredAllWhenExistAny:dteapkpi-actbedon-mtrvalue,dteapkpi-actbedon-mtrvalue|date_format:DD/MM/YYYY|notDuplicate',
    inlineFlgEditDisabled: true,
    dataType: 'date'
  }, {
    key: 'actbedon',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '160',
    style: 'min-width: 200px;',
    validateRules: 'requiredAllWhenExistAny:dteapkpi-actbedon-mtrvalue,dteapkpi-actbedon-mtrvalue|max:300',
    inlineType: 'text',
    maxlength: 300
  }, {
    key: 'mtrvalue',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '190',
    style: 'min-width: 80px;',
    inlineType: 'number',
    validateRules: 'requiredAllWhenExistAny:dteapkpi-actbedon-mtrvalue,dteapkpi-actbedon-mtrvalue|max:14',
    summary: true,
    maxlength: 11
  }, {
    key: 'mtrvalnet',
    name: '',
    labelCodapp: 'HRESS1EC2',
    labelIndex: '200',
    style: 'min-width: 100px;'
  }]

  return {
    en: {
      index: indexColumns,
      detail1Columns: detail1Columns,
      detail2Columns: detail2Columns
    },
    th: {
      index: indexColumns,
      detail1Columns: detail1Columns,
      detail2Columns: detail2Columns
    }
  }
}




// WEBPACK FOOTER //
// ./src/assets/columns/hress1e.js